import type { SVGProps } from "react";

export function ElevatorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        d="m132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4S73.5 96 80 96h128c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0M64 128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zm96 96a48 48 0 1 1 0 96a48 48 0 1 1 0-96M80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32zm32-128a48 48 0 1 1 96 0a48 48 0 1 1-96 0m52.7-180.7c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4z"
      />
    </svg>
  );
}
